<template>
  <v-card min-height="600" >
    <v-card-title>
      <span class="text-h5">Dettaglio distinta</span>
    </v-card-title>
    <v-card-text>
      <v-container fluid>
        <v-row dense>  
          <v-col >
            <v-simple-table dense class="mt-1">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="3%">LIV.</th>
                    <th class="text-left" width="4%">TIPO</th>
                    <th class="text-left" width="20%">CODICE</th>
                    <th class="text-left">DESCRIZIONE</th>
                    <th class="text-left" width="4%">UM</th>
                    <th class="text-right" width="15%">VALORE</th>
                    <!-- <th class="text-right"></th> -->
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in distinta" :key="index" :class="{ semilavorato: item.semilavorato, manuale: item.manuale }" @click="onClickRow(item)">
                    <td class="text-left">{{ item.livello }}</td>
                    <td class="text-left"><v-icon :title="titoloIcona(item)" :color="colori[item.tipo]">{{ icona(item) }}</v-icon></td>
                    <td class="text-left" v-if="item.tipo !== 'nota'">{{ item.codice }}</td>
                    <td class="text-left" :class="{ mancanzaValore: !item.descrizione}" v-if="item.tipo !== 'nota'">{{ item.descrizione || 'Inserire il valore' }}</td>
                    <td class="text-left" v-else colspan="2">{{ item.descrizione }}</td>
                    <td class="text-left">{{ item.unitaMisura }}</td>
                    <td class="text-right">{{ !['nota', 'multiselect'].includes(item.tipo) ? item.valore || item.quantita || '' : '' }}</td>
<!--                     <td class="text-right">
                      <v-btn v-if="(!item.semilavorato && item.livello !== 0) || (item.livello === 0 &&  item.items && item.items.length === 0)" icon @click.stop="deleteItem(item)" title="Cancella l'elemento"><v-icon small>mdi-delete</v-icon></v-btn>
                      <v-btn icon @click.stop="onNuovoProdotto(item, index)" title="Aggiungi un prodotto figlio"><v-icon>mdi-plus-circle-outline</v-icon></v-btn>
                    </td> -->
                  </tr>
                </tbody>                
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <!-- <aggiorna-prodotto :showDialog="dialogProdotto" :editedItem="editedItem" :clearInfo="clearInfo" :popolaInfo="popolaInfo" @aggiornaProdotto="saveDialogProdotto" /> -->
<!--     <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Confermi cancellazione riga ?</v-card-title>
        <v-card-text>{{ dettaglioRiga }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="deleteItemConfirm">SI</v-btn>
          <v-btn color="blue darken-1" text @click="closeDelete">NO</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
  </v-card>  
</template>
<script>
  import { v4 as uuidv4 } from 'uuid'
  /* import AggiornaProdotto from './aggiornaProdotto' */
  import documenti from '@/services/documentiService'
  
  export default {
/*     components: {
      AggiornaProdotto
    }, */
    props: {
      documento: Object,
      trigger: Number
    },
    data () {
      return {
        updateTrigger: 1,
        distinta: [],
        dialogProdotto: false,
        dialogDelete: false,
        editedIndex: -1,
        editedItem: {
          tipo: 'prodotto',
          codice : '',
          descrizione: '',
          unitaMisura: "",
          quantita: '',
          livello: 0
        },
        defaultItem: {
          tipo: 'prodotto',
          codice : '',
          descrizione: '',
          unitaMisura: "",
          quantita: '',
          livello: 0
        },
        popolaInfo: 1,
        clearInfo: 1,
        colori: {
          nota: '#d3d5ff',
          paramentro: '#d7ffd3',
          prodotto: '#f3ffc9',
          multiselect: '#ffd3d3'
        }
      }
    },
    watch: {
      async documento() {
        await this.elaboraDistinta(1)
      },
      async trigger() {
        await this.elaboraDistinta(1)
      }   
    },
    async mounted() {
      await this.elaboraDistinta(1)
    },
    computed: {
      dettaglioRiga() {
        let riga = this.editedIndex
        if (riga === -1) return
        let ed = this.distinta[riga]
        if (!ed) return ''
        return ed.descrizione.trim()       
      }
    },
    methods: {
      aggiornaDistinta() {
        const distinta = this.creaDistintaDocumento(0)
        // console.log('aggiorna', distinta.dd)
        this.$emit('aggiornaDistinta', distinta.dd)
      },
      icona(item) {
        switch(item.tipo) {
          case 'nota':
            return 'mdi-note-outline'
          case 'parametro':
            return 'mdi-cog-outline'
          case 'multiselect':
            return 'mdi-selection-multiple'
          default:
            if (item.manuale) {
              return 'mdi-hand-back-left-outline'
            }
            return ''
        }
      },
      titoloIcona(item) {
        switch(item.tipo) {
          case 'nota':
            return 'Nota'
          case 'parametro':
            return 'Parametro'
          case 'multiselect':
            return 'Selezione multipla'
          default:
            if (item.manuale) {
              return 'Inserimento manuale'
            }
            return ''
        }
      },      
      onClickRow(item) {
        this.editItemProdotto(item)
      },
      editItemProdotto (item) {
        this.editedIndex = this.distinta.indexOf(item)
        item.valori = item.valori || []
        this.editedItem = Object.assign({}, item)
        this.popolaInfo++
        this.dialogProdotto = true
      },
      closeDialogProdotto() {
        this.dialogProdotto = false
        this.$nextTick(() => {
          this.clearInfo++
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },      
      saveDialogProdotto(item) {
        if (item) {
          this.editItem = item
          if (this.editedIndex > -1) {
            Object.assign(this.distinta[this.editedIndex], this.editedItem)
          } else {
            this.distinta.push(this.editedItem)
          }
        }
        this.aggiornaDistinta()
        this.closeDialogProdotto()
      },
      async elaboraDistinta(qta) {
        if (!this.documento) return
        const codice = _.get(this.documento, 'bom.gestione.distinta.codice')
        if (codice) {
          const documento = await documenti.getDocumento(codice)
          const elenco = this.elaboraItem(documento.distinta, qta, 0)
          this.distinta = elenco
        }
      },
      elaboraItem(item, qta = 1, livello) {
        if (!item) return []
        let elenco = []
        if (item.items) {
          elenco.push({ livello: livello, tipo:item.tipo || 'prodotto', richiedeLotto: item.richiedeLotto, codice: item.codice, descrizione: item.descrizione || '', quantita: +(qta * (item.quantita || 1)).toFixed(2), valore: item.valore, semilavorato: true, unitaMisura: item.unitaMisura })
          for (let i of item.items) {
            const totQta = qta * item.quantita
            elenco = elenco.concat(this.elaboraItem(i, totQta, livello + 1))
          }
        } else {
          let valori = item.valori || []
          elenco.push({ livello, tipo:item.tipo || 'prodotto', richiedeLotto: item.richiedeLotto, codice: item.codice, descrizione: item.descrizione || '', quantita: +(qta * (item.quantita || 1)).toFixed(2), valore: item.valore, semilavorato: false, unitaMisura: item.unitaMisura, valori: valori })
        }
        return elenco
      },
      deleteItem (item) {
        this.editedIndex = this.distinta.indexOf(item)
        this.dialogDelete = true
      },
      async deleteItemConfirm () {
        let d = this.distinta
        d.splice(this.editedIndex, 1)
        let pp = d[this.editedIndex - 1]
        let ss = this.editedIndex <= d.length ? d[this.editedIndex] : null
        if (!ss || (ss && ss.livello === pp.livello)) {
          this.distinta[this.editedIndex - 1].semilavorato = false
        }
        this.closeDelete()
        this.editedIndex = -1
        this.aggiornaDistinta()
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedIndex = -1
        })
      },
      async onNuovoProdotto(item, index) {
        let newItem = JSON.parse(JSON.stringify(this.defaultItem))
        newItem.livello = item ? item.livello + 1 : 0

        newItem.quantita = ''
        // newItem.usato = 0
        // newItem.manuale = true
        newItem.tipo = 'prodotto'
        //const insertionPosition = index + 2
        let childs = 0
        let d = this.distinta
        if (item) {
          item.semilavorato = true
          let el = d.indexOf(item)
          while (++el < d.length) {
            const dd = d[el]
            if (!dd.semilavorato && dd.livello > item.livello) {
              childs++
            } else {
              break
            }
          }
        }
        const insertionPosition = index + childs + 1
        const list1 = this.distinta.splice(0, insertionPosition)
        const list2 = this.distinta
        this.distinta = [...list1, newItem, ...list2]
        // this.aggiornaDistinta()
        await this.$nextTick()
        this.editItemProdotto(newItem)
      },
      creaDistintaDocumento(k = 0) {
        // console.log('entrato', k)
        var dd = {}
        // console.log('en1', k, this.distinta.length, this.distinta[k].descrizione)
        let d = this.distinta[k]
        dd.livello = d.livello
        dd.quantita = d.quantita
        dd.unitaMisura = d.unitaMisura || ''
        dd.valore = d.valore
        dd.valori = d.valori
        dd.codice = d.codice
        dd.descrizione = d.descrizione
        dd.tipo = d.tipo
        console.log('prima..', dd.id)
        dd.id = uuidv4()
        console.log('dopo..', dd.id)
        k++
        // console.log('en2', k, d, d.semilavorato)
        if (d.semilavorato) {
          let livello = this.distinta[k].livello
          dd.items = []
          // console.log('en3', this.distinta[k].livello, livello, k, this.distinta.length)
          while(k < this.distinta.length && this.distinta[k].livello === livello) {
            // console.log('en4', k, this.distinta[k].descrizione)
            const res = this.creaDistintaDocumento(k)
            dd.items.push(res.dd)
            // console.log('ret', k, res.k)
            k = res.k
          }
        }
        // console.log('out', k)
        return { dd, k }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .v-input {
    font-size: 14px;
  }
  .semilavorato {
    background-color: rgb(222, 228, 233);
  }
  .manuale {
    background-color: rgb(193, 241, 183);
  }
  .mancanzaValore {
    color: red;
  }
</style>
